import React                     from 'react';
import {connect}                 from 'react-redux';
import { Modal }                 from 'react-bootstrap';
import FlashRetornoNulo          from '../../../container/FlashRetornoNulo';
import { GetAdicionarAlunoEquipe, 
         SetAdicionarAlunoEquipe, 
         RemoverAlunoEquipe,
        GetGruposAlunos }        from '../../../actions/grupoAction';
import FotoPerfil                from '../../../container/renderFotoPerfil';
import { ActionModal }           from '../../../actions/scopoAction';
import EquipeAdicionarAluno      from './equipe_adicionar_aluno_equipe';

class Equipe_Professor_Turma_List extends React.Component {

    constructor(props){

            super(props);
            this.state = {
                          load2         : false,
                          list_id_aluno : [],
                          use_id        : this.props.session.id,
                          disabled      : true
                         }

            this.removerAlunoEquipe = this.removerAlunoEquipe.bind(this);
    }
 
    removerAlunoEquipe(alu_id,equ_id){
          
      this.props.RemoverAlunoEquipe(alu_id,equ_id,this.props.session.id);
   
    }
   
    renderListar(){
        this.props.GetGruposAlunos(this.props.equ_id);
    }

    close() {
        this.props.ActionModal(false);
        this.setState({ list_id_aluno : [] });
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.actionModal){
           this.setState({showModal: true });
        }else{
           this.setState({showModal: false });
        }
    }

    renderAlunosEquipe(){

        const listEquipesAlunos = this.props.alunosEquipes;
       
        if(listEquipesAlunos) {
            return listEquipesAlunos.map((elem, valKey) =>{
                return  <tr key={valKey} id={`aluno_${elem.use_id}`}>
                            <td className="text-center" ><FotoPerfil alt="" width="25" height="25" className="img-rounded" src={elem.use_foto}/></td> 
                            <td className="text-center">{elem.use_nome}</td>
                            <td className="text-center">{elem.nome_professor}</td>
                            <td className="text-center">
                            {this.props.session.id === elem.alu_equ_cod_professor ?
                                <button className="btn btn-danger btn-xs" onClick={this.removerAlunoEquipe.bind(this,elem.use_id,elem.alu_equ_cod_equipe)}>
                                    <span className="glyphicon glyphicon-remove"></span>
                                </button>:
                                <button className="btn btn-danger btn-xs" disabled>
                                        <span className="glyphicon glyphicon-remove"></span>
                                </button>}
                            </td>
                        </tr>
                });
            
        } else {
            return <tr> <td colSpan={4} className="text-center"><FlashRetornoNulo/></td></tr>;
        }
   } 

    render() {
                return (
                    <div>
                    <div className="panel panel-azul-claro panel-cinza">
                        <div className="panel-body">
                        <table className="table table_panel">
                            <thead> 
                            <tr> 
                            <th className="text-center">Fotos</th> 
                            <th className="text-center">Alunos</th> 
                            <th className="text-center">Prof. Responsável</th> 
                            <th className="text-center">Ação</th> 
                            </tr> 
                            </thead> 
                            <tbody> 
                            { this.renderAlunosEquipe() }
                            </tbody> 
                        </table>
                        </div>
                        </div>

                        <Modal show={this.state.showModal} onHide={this.close.bind(this)}>
                           <EquipeAdicionarAluno equ_id={this.props.equ_id}/>
                        </Modal>                                             
                    </div>);
        }

}

function mapStateToProps(state){

    return {
      session            : state.auth.session,
      alunosEquipes      : state.equipeReducer.alunos,
    //  all_dicionar_aluno : state.equipeReducer.all_aluno_adicionar_equipe,
      nome_equipe        : state.equipeReducer.nome_equipe,
      actionModal        : state.scopoReducer.actionModal
    }
}

export default connect(mapStateToProps,{GetAdicionarAlunoEquipe,SetAdicionarAlunoEquipe,RemoverAlunoEquipe,GetGruposAlunos,ActionModal})(Equipe_Professor_Turma_List);




// WEBPACK FOOTER //
// ./src/components/professor/equipe/equipe_professor_turma_aluno_list.js